import { render, staticRenderFns } from "./FormImageBase64.vue?vue&type=template&id=4039d718&scoped=true&"
import script from "./FormImageBase64.vue?vue&type=script&lang=ts&"
export * from "./FormImageBase64.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039d718",
  null
  
)

export default component.exports